import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./components/Home.vue";
import NaTimer from "./components/Timer";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/timer/:minutesToRun",
    name: "timer",
    component: NaTimer,
    props: true
  }
];

export default new VueRouter({
    routes: routes
});


// WEBPACK FOOTER //
// ./src/routes.js